function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "m19.8645 18.3208h-.813l-.2882-.2779c1.0086-1.1733 1.6158-2.6964 1.6158-4.3534 0-3.69465-2.9949-6.6895-6.6896-6.6895-3.69465 0-6.6895 2.99485-6.6895 6.6895 0 3.6947 2.99485 6.6896 6.6895 6.6896 1.657 0 3.1801-.6072 4.3534-1.6158l.2779.2882v.813l5.1458 5.1355 1.5334-1.5334zm-6.175 0c-2.5626 0-4.63118-2.0687-4.63118-4.6313s2.06858-4.63118 4.63118-4.63118 4.6313 2.06858 4.6313 4.63118-2.0687 4.6313-4.6313 4.6313z",
  fill: "#303030"
});

var SvgKeywords = function SvgKeywords(props) {
  return React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 32 32",
    width: 32
  }, props), _ref);
};

export default "data:image/svg+xml;base64,";
export { SvgKeywords as ReactComponent };